import type { TRootState } from 'store';
import type { ITableSelector } from 'interfaces/Table/selector.interface';
import { createTableSelectorSlice } from 'redux/table/helper/createTableSelector.slice';
import {
  itemsPerPageDefault,
  currentPageDefault,
} from 'redux/table/consts/tableDefaults.consts';

export const projectShiftsSlice = createTableSelectorSlice(
  'paginatedProjectShifts',
  currentPageDefault,
  itemsPerPageDefault
);

const { actions, reducer } = projectShiftsSlice;

export const {
  setPagination,
  setNextPage,
  setSorting,
  setItemsPerPage,
  setFilters,
  setInitialFiltersSet,
  setMenuColumnList,
} = actions;

export const paginatedProjectShiftsSelector = (
  state: TRootState
): ITableSelector => state.tableProjectShifts;

export default reducer;
